'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _TextareaAutosize = require('./TextareaAutosize.js');

var _TextareaAutosize2 = _interopRequireDefault(_TextareaAutosize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TextareaAutosize2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-autosize-textarea/lib/index.js
// module id = 923
// module chunks = 0